import {useEffect, useMemo, useState} from "react";
import {checkDirRights} from "../../shared/helpers/checkDirRights";

/**
 * Хук для управления списком справочников и работы с localStorage.
 *
 * Этот хук:
 * 1. Загружает список справочников из localStorage или вызывает функцию для его получения, если в localStorage нет данных.
 * 2. Фильтрует полный список справочников на основе прав пользователя.
 * 3. Кэширует отфильтрованный список справочников в localStorage, если его там еще нет.
 *
 * @param {string} storageKey - Ключ для хранения списка справочников в localStorage.
 * @param {Function} getDirectoryList - Функция для получения списка справочников, если его нет в localStorage.
 * @param {Array} listFull - Полный список справочников для фильтрации на основе прав пользователя.
 * @param {Object} rights - Объект, содержащий права пользователя для фильтрации справочников.
 * @returns {Array} Отфильтрованный список справочников на основе прав пользовател:
 */

export const useDirectoryList = (storageKey, getDirectoryList, listFull, rights) => {

    const [directoryList, setDirectoryList] = useState([]);
    const isKeyObject = Object.keys(rights)?.length

    useEffect(() => {

        const cachedDirectoryList = localStorage.getItem(storageKey);

        if (cachedDirectoryList) {
            setDirectoryList(JSON.parse(cachedDirectoryList));
        } else {
            getDirectoryList();
        }
    }, [getDirectoryList, storageKey]);

    useEffect(() => {
        if (!listFull || !listFull.length)  return

        if (directoryList?.length)  return;

        const filteredList = listFull.filter(({id}) => checkDirRights(id, rights));
        localStorage.setItem(storageKey, JSON.stringify(filteredList));
        setDirectoryList(filteredList)

    }, [listFull?.length, isKeyObject, storageKey])

    return directoryList;
};